webpackJsonp([2],{

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_create_by_home_vue__ = __webpack_require__(294);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49042e07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_create_by_home_vue__ = __webpack_require__(434);
function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var normalizeComponent = __webpack_require__(143)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49042e07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoice_create_by_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49042e07_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoice_create_by_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(296)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_json__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_config_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InvoiceCreateByHome',
  data: function data() {
    return {
      search: '',
      zone_id: '',
      zone_list: [],
      searched: false,
      home_list: [],
      selected_home: null,
      date_bill: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM'),
      loading: false,
      preview: null,
      preview_loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var header = {
      headers: {
        'access-token': this.$store.state.token
      }
    };
    this.axios.get(__WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.URL + 'homezone/all', header).then(function (response) {
      if (response.data && response.data.response) {
        _this.zone_list = response.data.data || [];
      }
    }).catch(function () {});
  },

  watch: {
    date_bill: function date_bill() {
      if (this.selected_home) {
        this.fetchPreview();
      }
    }
  },
  methods: {
    numberFormat: function numberFormat(value) {
      var n = Number(value);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n)) return value;
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    fetchPreview: function fetchPreview() {
      var _this2 = this;

      if (!this.selected_home || !this.date_bill) {
        this.preview = null;
        return;
      }

      this.preview_loading = true;
      var header = {
        headers: {
          'access-token': this.$store.state.token
        }
      };
      var payload = {
        home_id: this.selected_home.home_id,
        date_bill: this.date_bill + '-16'
      };

      this.axios.post(__WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.URL + 'invoice/previewbyhome', payload, header).then(function (response) {
        _this2.preview_loading = false;
        if (response.data && response.data.response) {
          _this2.preview = response.data.data;
        } else {
          _this2.preview = null;
        }
      }).catch(function () {
        _this2.preview_loading = false;
        _this2.preview = null;
      });
    },
    searchHome: function searchHome() {
      var _this3 = this;

      if (!this.search) return;
      this.searched = true;
      this.selected_home = null;
      this.loading = true;
      this.preview = null;

      var header = {
        headers: {
          'access-token': this.$store.state.token
        }
      };

      var filter = {
        search: this.search,
        zone: this.zone_id,
        active_page: 1,
        per_page: 50
      };

      this.axios.post(__WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.URL + 'home/search', filter, header).then(function (response) {
        _this3.loading = false;
        if (response.data.response) {
          _this3.home_list = response.data.data.pagination;
        } else {
          _this3.home_list = [];
        }
      }).catch(function (err) {
        _this3.loading = false;
        console.error(err);
        alert('เกิดข้อผิดพลาดในการค้นหา');
      });
    },
    selectHome: function selectHome(home) {
      this.selected_home = home;
      this.fetchPreview();
    },
    createInvoice: function createInvoice() {
      var _this4 = this;

      if (!this.selected_home || !this.date_bill) return;

      if (!confirm('ยืนยันการสร้างใบแจ้งหนี้สำหรับ ' + this.selected_home.home_number + ' ประจำเดือน ' + this.date_bill + '?')) return;

      this.loading = true;

      var header = {
        headers: {
          'access-token': this.$store.state.token
        }
      };

      var payload = {
        home_id: this.selected_home.home_id,
        date_bill: this.date_bill + '-16'
      };

      this.axios.post(__WEBPACK_IMPORTED_MODULE_2__static_config_json___default.a.URL + 'invoice/generatebyhome', payload, header).then(function (response) {
        _this4.loading = false;
        if (response.data.response) {
          alert('สร้างใบแจ้งหนี้เรียบร้อยแล้ว');
          _this4.selected_home = null;
          _this4.search = '';
          _this4.home_list = [];
          if (response.data.invoice_id) {
            _this4.$router.push({ name: 'InvoiceDetail', params: { key: response.data.invoice_id } });
          }
        } else {
          alert('ไม่สามารถสร้างใบแจ้งหนี้ได้: ' + (response.data.message || 'Unknown error'));
        }
      }).catch(function (err) {
        _this4.loading = false;
        if (err.response && err.response.data && err.response.data.message) {
          alert('ข้อผิดพลาด: ' + err.response.data.message);
        } else {
          alert('เกิดข้อผิดพลาดในการเชื่อมต่อระบบ');
        }
      });
    },
    formatThaiMonth: function formatThaiMonth(dateStr) {
      if (!dateStr) return '';
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateStr);
      var months = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
      return months[date.month()] + ' ' + (date.year() + 543);
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 296:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(419);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(187)("144b83f2", content, true, {});

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(186)(true);
// imports


// module
exports.push([module.i, ".list-group-item[data-v-49042e07]{cursor:pointer}.list-group-item[data-v-49042e07]:hover{background-color:#f8f9fa}.active[data-v-49042e07]{background-color:#007bff!important;color:#fff!important}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/views/invoice_create_by_home.vue"],"names":[],"mappings":"AACA,kCACI,cAAgB,CACnB,AACD,wCACI,wBAA0B,CAC7B,AACD,yBACI,mCAAqC,AACrC,oBAAwB,CAC3B","file":"invoice_create_by_home.vue","sourcesContent":["\n.list-group-item[data-v-49042e07] {\r\n    cursor: pointer;\n}\n.list-group-item[data-v-49042e07]:hover {\r\n    background-color: #f8f9fa;\n}\n.active[data-v-49042e07] {\r\n    background-color: #007bff !important;\r\n    color: white !important;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(421), __esModule: true };

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(422);
module.exports = __webpack_require__(149).Number.isNaN;


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(423);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(295);
var core = __webpack_require__(149);
var ctx = __webpack_require__(424);
var hide = __webpack_require__(426);
var has = __webpack_require__(433);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(425);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(427);
var createDesc = __webpack_require__(432);
module.exports = __webpack_require__(256) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(428);
var IE8_DOM_DEFINE = __webpack_require__(429);
var toPrimitive = __webpack_require__(431);
var dP = Object.defineProperty;

exports.f = __webpack_require__(256) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(255);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(256) && !__webpack_require__(296)(function () {
  return Object.defineProperty(__webpack_require__(430)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(255);
var document = __webpack_require__(295).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(255);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 433:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"invoice-create-by-home"}},[_c('div',{staticClass:"card",style:({ 'min-height': _vm.$store.state.screenHeight - 140 + 'px' })},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_c('i',{staticClass:"fas fa-file-invoice-dollar"}),_vm._v("\n        "+_vm._s(_vm.$route.meta.title)+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โซน:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone_id),expression:"zone_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.zone_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- ทั้งหมด --")]),_vm._v(" "),_vm._l((_vm.zone_list),function(z,i){return _c('option',{key:'zone' + i,domProps:{"value":z.zone_id}},[_vm._v("\n                  ("+_vm._s(z.zone_code)+") "+_vm._s(z.zone_name)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหาบ้านเลขที่:")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรอกบ้านเลขที่, ชื่อเจ้าบ้าน..."},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchHome($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.searchHome}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" ค้นหา\n                  ")])])])]),_vm._v(" "),(_vm.date_bill)?_c('div',{staticClass:"mb-3"},[_c('label',[_vm._v("ประจำเดือน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_bill),expression:"date_bill"}],staticClass:"form-control",attrs:{"type":"month"},domProps:{"value":(_vm.date_bill)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_bill=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.home_list.length > 0)?_c('div',{staticClass:"list-group"},_vm._l((_vm.home_list),function(home,index){return _c('a',{key:index,staticClass:"list-group-item list-group-item-action",class:{ 'active': _vm.selected_home && _vm.selected_home.home_id === home.home_id },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.selectHome(home)}}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h5',{staticClass:"mb-1"},[_vm._v("บ้านเลขที่ "+_vm._s(home.home_number)+" (โซน "+_vm._s(home.zone_code)+")")])]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_vm._v("ชื่อเจ้าบ้าน: "+_vm._s(home.home_fullname))]),_vm._v(" "),_c('small',[_vm._v("เบอร์โทร: "+_vm._s(home.home_phone))])])}),0):(_vm.searched)?_c('div',{staticClass:"text-center mt-3 text-muted"},[_vm._v("\n              ไม่พบข้อมูลบ้านที่ค้นหา\n            ")]):_vm._e(),_vm._v(" "),(_vm.selected_home)?_c('div',{staticClass:"card mt-3 border-primary"},[_c('div',{staticClass:"card-header bg-primary text-white"},[_vm._v("\n                ยืนยันการสร้างใบแจ้งหนี้\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('p',[_c('strong',[_vm._v("บ้านเลขที่:")]),_vm._v(" "+_vm._s(_vm.selected_home.home_number))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("เจ้าบ้าน:")]),_vm._v(" "+_vm._s(_vm.selected_home.home_fullname))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("เดือนที่จะออกใบแจ้งหนี้:")]),_vm._v(" "+_vm._s(_vm.formatThaiMonth(_vm.date_bill)))]),_vm._v(" "),(_vm.preview_loading)?_c('div',{staticClass:"text-center my-3"},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                  กำลังโหลดรายการค่าใช้จ่าย...\n                ")]):(_vm.preview)?_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                    รายการค่าใช้จ่าย (Preview)\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table mb-0"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("ค่าส่วนกลาง")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_central)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("ค่าน้ำ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_water)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("ค่าอื่นๆ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_other)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("ค่าไฟ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_electric)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("ยอดค้างชำระเดิม")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_overdue)))])]),_vm._v(" "),_c('tr',{staticClass:"table-primary"},[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.numberFormat(_vm.preview.summary.sum_total_due)))])])])])])]),_vm._v(" "),(_vm.preview.current_month && _vm.preview.current_month.water_meter)?_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_vm._v("เลขมิเตอร์ปัจจุบัน: "+_vm._s(_vm.preview.current_month.water_meter.water_income_unit))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_vm._v("เลขมิเตอร์ก่อนหน้า: "+_vm._s(_vm.preview.current_month.water_meter.water_total_last_unit))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_vm._v("หน่วยที่ใช้: "+_vm._s(_vm.preview.current_month.water_meter.diff_unit))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_vm._v("ค่าน้ำ: "+_vm._s(_vm.numberFormat(_vm.preview.current_month.water_meter.water_income_price)))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-lg btn-block",attrs:{"disabled":_vm.loading || _vm.preview_loading},on:{"click":_vm.createInvoice}},[(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_c('span',[_c('i',{staticClass:"fas fa-check-circle"}),_vm._v(" สร้างใบแจ้งหนี้")])])])]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("รวมที่ต้องชำระ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("มิเตอร์น้ำเดือนนี้:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" ระบบจะทำการตรวจสอบว่ามีใบแจ้งหนี้ของเดือนนี้อยู่แล้วหรือไม่\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.ec3afd00a836169d746c.js